import api from '@/js/services/axios'

/**
 * API for organization membership templates (plans the org offers to participants).
 * Backend: /api/private/v1/org/{orgId}/membership-templates
 */
const BASE = 'private/v1/org/{orgId}/membership-templates'

export default {

  // Duration type constants (must match backend)
  DURATION_TYPE_DAYS: 'DAYS',
  DURATION_TYPE_WEEKS: 'WEEKS',
  DURATION_TYPE_MONTHS: 'MONTHS',
  DURATION_TYPE_CALENDAR_MONTHS: 'CALENDAR_MONTHS',


  /**
   * Get all membership templates for the current organization
   * @returns {Promise<Array>} List of membership templates (RMembershipPrivateDto)
   */
  getAllMembershipTemplates: async () => {
    return new Promise((resolve, reject) => {
      api.get(BASE)
        .then(response => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /**
   * Get a single membership template by ID
   * @param {number} membershipTemplateId - r_membership_template_id from API
   * @returns {Promise<Object>} Membership template object
   */
  getMembershipTemplateById: async (membershipTemplateId) => {
    return new Promise((resolve, reject) => {
      api.get(BASE + '/' + membershipTemplateId)
        .then(response => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /**
   * Create a new membership template
   * @param {Object} membershipTemplateData - Template data (name, duration_type, duration_number, event_count, price, etc.)
   * @returns {Promise<Object>} Created membership template
   */
  createMembershipTemplate: async (membershipTemplateData) => {
    return new Promise((resolve, reject) => {
      api.post(BASE, membershipTemplateData)
        .then(response => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /**
   * Update a membership template (PATCH)
   * @param {number} membershipTemplateId - r_membership_template_id from API
   * @param {Object} membershipTemplateData - Updated template data
   * @returns {Promise<Object>} Updated membership template
   */
  updateMembershipTemplate: async (membershipTemplateId, membershipTemplateData) => {
    return new Promise((resolve, reject) => {
      api.patch(BASE + '/' + membershipTemplateId, {
        is_patch: true,
        ...membershipTemplateData
      })
        .then(response => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /**
   * Delete a membership template
   * @param {number} membershipTemplateId - r_membership_template_id from API
   * @returns {Promise<void>}
   */
  deleteMembershipTemplate: async (membershipTemplateId) => {
    return new Promise((resolve, reject) => {
      api.delete(BASE + '/' + membershipTemplateId)
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
